import SVGInject from '@iconfu/svg-inject';

class SvgIcon {
  constructor(options = {}) {
    this.config = {
      module: document.querySelectorAll('[data-module="SvgIcon"]'),
      ...options
    };
  }

  init() {
    SVGInject(this.config.module);
  }
}

export default SvgIcon;
